const SECONDS_PER_MINUTE = 60

export function formatCountdown(seconds: number): string {
  if (seconds < SECONDS_PER_MINUTE) return `${seconds}s`
  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE)
  const remainder = String(seconds % SECONDS_PER_MINUTE).padStart(2, '0')
  return `${minutes}:${remainder}`
}
